//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "Serum_permeation_gap",
  data() {
    return {
      form: {
        na: "",
        k: "",
        bun: "",
        mo: "",
        glu:''
      },
      hasScore: false,
      disabled: false,
      dataList: [
        { value: "1", name: "女" },
        { value: "2", name: "男" },
      ],
    };
  },
  created() {
    this.hideLoad();
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      let flag = true;
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            if (form[key] == "---") {
              flag = false;
            } else {
              form[key] = Number(form[key]);
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false;
        return "--";
      } else {
        let co = (form.na + form.k) + 1.15 * (form.glu / 18) + form.bun / 6 + 14
        let result = (form.mo - co).toFixed(2)
        self.hasScore = true;
        return result;
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/Serum_permeation_gap.vue